import { UserContext } from "@/context";
import { useSuspenseQuery } from "@tanstack/react-query";
import { userQuery } from "@/queries.ts";
import type { PropsWithChildren } from "react";
import * as Sentry from "@sentry/react";

export const UserProvider = ({ children }: PropsWithChildren) => {
  const { data: user } = useSuspenseQuery(userQuery);
  Sentry.setUser({ id: user.id });
  return (
    <UserContext.Provider value={{ user }}>{children}</UserContext.Provider>
  );
};
